module.exports = __webpack_public_path__ + "img/35-7cd7fd.png";